import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { remToPixels } from '../../../base/ui/functions.any';
import { DISPLAY_NAME_BADGE_BORDER_RADIUS } from '../../../meeting-ui/constants';
import { DISPLAY_NAME_VERTICAL_PADDING } from './styles';
const useStyles = makeStyles()(theme => {
    const { text01 } = theme.palette;
    return {
        badge: {
            background: theme.palette.thumbnailLabelBackground,
            borderRadius: `${DISPLAY_NAME_BADGE_BORDER_RADIUS}px`,
            color: text01,
            fontWeight: 500,
            maxWidth: '50%',
            overflow: 'hidden',
            padding: `${remToPixels(`${DISPLAY_NAME_VERTICAL_PADDING}rem`) / 2}px 16px`,
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    };
});
/**
 * Component that displays a name badge.
 *
 * @param {Props} props - The props of the component.
 * @returns {ReactElement}
 */
const DisplayNameBadge = ({ name }) => {
    const { classes } = useStyles();
    return (React.createElement("div", { className: classes.badge }, name));
};
export default DisplayNameBadge;
